import React from 'react';

export const Svg = ({ size, colour, svg_list, svg_classname, ...props }) => {
    const svgColour = colour != undefined ? `mz-svg--${colour}` : null;
    
    return (
        <i  style={{'fontSize': (size) + 'rem'}} className={['mz-svg', svgColour, `mz-svg-${svg_list}`].join(' ')}></i>
    );
};